import React, { useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser } from "../../../../store/features/loginUser";
import './style.css';
import { updateKbUserRole, resetState } from '../../../../store/features/updateKbUserRole';
import { getKbGroupId } from '../../../../utils/kbGroupId';

function KnowledgeBaseRole(props) {
  const { kbRole, userId, businessId, getUserlList } = props;  // ✅ Destructure kbRole
  const [selectedRole, setSelectedRole] = useState(kbRole || '');
  const dispatch = useDispatch();

  // Get user data from Redux
  const userData = useSelector((state) => state.loginToken);
  const uRole = userData?.response?.user?.role_name;

  // Get loading state from Redux
  const isLoading = useSelector((state) => state.updateKbUserRole?.isLoading);

  const handleUpdateRole = ({ userId, businessId, role }) => {
    dispatch(updateKbUserRole({ userId, businessId, role, group_id: getKbGroupId() }))
      .unwrap()
      .then((data) => {
        if (data?.status === 200) {
          toast.success(data?.message || 'Role updated successfully');

          // ✅ UPDATE LOCAL STORAGE
          if (userId === userData.response?.user?._id) {
            const storedLoginToken = localStorage.getItem('persist:root');
            if (storedLoginToken) {
              const parsedRoot = JSON.parse(storedLoginToken);
              let loginToken = JSON.parse(parsedRoot.loginToken);

              if (
                loginToken &&
                loginToken.response &&
                loginToken.response.user
              ) {
                loginToken.response.user.kbRole = {
                  ...(loginToken.response.user.kbRole || {}),
                  role: role,
                };

                parsedRoot.loginToken = JSON.stringify(loginToken);
                localStorage.setItem(
                  'persist:root',
                  JSON.stringify(parsedRoot)
                );

                // ✅ UPDATE REDUX STATE (important for instant UI)
                dispatch(
                  updateUser({
                    user: {
                      kbRole: {
                        role: role,
                      },
                    },
                  })
                );
              }
            }
          }
          getUserlList();
        } else {
          toast.error(
            data?.message || 'Some Error Occurred. Please try again later.'
          );
        }
      })
      .catch((err) => {
        toast.error(err || 'An error occurred');
      });
  };


  const handleRoleChange = (event) => {
    const newRoleName = event.target.value;
    setSelectedRole(newRoleName);
    handleUpdateRole({ userId, businessId, role: newRoleName });
  };

  const allRoles = [
    {
      value: 'editor',
      label: 'Editor',
      description: 'Can view, create, edit, publish, archive, and delete content.',
    },
    {
      value: 'contributor',
      label: 'Contributor',
      description: 'Can view, create, and edit content, but must request review for publishing.',
    },
    {
      value: 'viewer',
      label: 'Viewer',
      description: 'Can view published content but cannot do anything else.',
    },
  ];

  const roles = uRole === 'admin'
    ? allRoles.filter(role => role.value !== 'editor')
    : allRoles;

  // ✅ Update selected role when kbRole prop changes
  useEffect(() => {
    setSelectedRole(kbRole || '');
  }, [kbRole]);

  // Reset state on unmount
  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);


  return (
    <Box sx={{ border: '1px solid #E5E9EC', borderRadius: '8px', backgroundColor: '#fff', marginTop: '8px' }}>
      <Typography sx={{
        paddingTop: '24px',
        paddingLeft: '24px',
        color: '#061522',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        height: '64px',
        lineHeight: '20px'
      }}>
        Knowledge Base
      </Typography>
      <Box sx={{ borderTop: '1px solid #E5E9EC', paddingLeft: '24px', paddingRight: '24px', paddingBottom: '24px' }}>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup value={selectedRole} onChange={handleRoleChange}>
            {roles.map((role) => (
              <Box key={role.value} sx={{ marginTop: '24px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Radio
                    value={role.value}
                    checked={selectedRole === role.value}
                    disabled={isLoading}
                    sx={{
                      padding: 0,
                      color: '#D5DCE1',
                      '&.Mui-checked': {
                        color: '#148DFD',
                      },
                      '& .MuiSvgIcon-root': {
                        fontSize: 16,
                      },
                    }}
                  />
                  <Typography sx={{
                    color: '#061522',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '20px'
                  }}>
                    {role.label}
                  </Typography>
                </Box>
                <Typography sx={{
                  marginTop: '4px',
                  marginLeft: '28px',
                  color: '#556575',
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '20px'
                }}>
                  {role.description}
                </Typography>
              </Box>
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
}

export default KnowledgeBaseRole;